import { Link } from 'react-router-dom'
import { AlertCircle } from 'lucide-react'

const Unauthorized = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <AlertCircle className="mx-auto h-12 w-12 text-red-500" />
        <h1 className="mt-4 text-3xl font-bold text-gray-900">
          Yetkisiz Erişim
        </h1>
        <p className="mt-2 text-gray-600">
          Bu sayfaya erişim yetkiniz bulunmamaktadır.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  )
}

export default Unauthorized




